import React, { useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import "./index.css";
import "./page.css";
// import logo_yourfairshare from "../../assets/logo_homepage3.svg";
// import Username from '../../components/Username/';
// import Percentage from '../../components/Percentage/';
// import logo from "../../assets/logo_mini_yourfairshare2.png";
// import Navigation from '../../components/Navigation';
// import bubbles from '../../assets/shapes_svg/bubbles.svg'
// import  React ,{useRef,useState,useEffect}from 'react'
// import { useReactToPrint } from "react-to-print";
import logo_default from "../../../assets/logo_azilis.png";
import scope1 from "../../../assets/shapes_svg/output/scope1.svg";
import scope2 from "../../../assets/shapes_svg/output/scope2.svg";
import scope3 from "../../../assets/shapes_svg/output/scope3.svg";
import governance2 from "../../../assets/shapes_svg/output/governance2.svg";
import PrintsIcon from "../../../components/EditIconTable/PrintsIcon";
import ClipLoader from "react-spinners/ClipLoader";
import prevpage from "../../../assets/shapes_svg/output/prevpage.svg";
import nextpage from "../../../assets/shapes_svg/output/nextpage.svg";
import { getFirstBusiness } from "../../../apis/Business/Business";
import "../reporting.css";
import PrintIcon from "@mui/icons-material/Print";
import grid3 from "../../../assets/shapes_svg/reporting/grid3.svg";
import grid2 from "../../../assets/shapes_svg/reporting/grid2.svg";
import { OurStateThisYear } from "./Pages/OurStateThisYear";
import { OurCompanyStructure } from "./Pages/OurCompanyStructure";
import { CompanyReportInformation } from "./Pages/CompanyReportInformation";
import { TableContents } from "./Pages/TableContents";
import { AmbitionAndStatus } from "./Pages/AmbitionAndStatus";
import { OurTransparency } from "./Pages/OurTransparency";
import { OurRiskAndOpportunitites } from "./Pages/OurRiskAndOpportunitites";
import { OurStakeholderInclusion } from "./Pages/OurStakeholderInclusion";
import { OurDiversityAndEquality } from "./Pages/OurDiversityAndEquality";
import { SocialActiveParticipation } from "./Pages/SocialActiveParticipation";
import { OurDiversityAndInclusion } from "./Pages/OurDiversityAndInclusion";
import { OurHealth } from "./Pages/OurHealth";
import { OurWorkplace } from "./Pages/OurWorkplace";
import {
  OurEnvironmentalAim,
  ActiveParticipation,
} from "./Pages/OurEnvironmentalAim";
import { BrandWay } from "./Pages/BrandWay";
import { BrandHighlight } from "./Pages/BrandHighlight";
import { OurGoals } from "./Pages/OurGoals";
import { EnvironmentAndOurWorld } from "./Pages/EnvironmentAndOurWorld";
import { Scope3 } from "./Pages/Scope3";
import { Scope2 } from "./Pages/Scope2";
import { Scope1 } from "./Pages/Scope1";
import { EnergyAndWater } from "./Pages/EnergyAndWater";
import { Social } from "./Pages/Social";
import { Governance } from "./Pages/Governance";
import { EUGreenDeal } from "./Pages/EUGreenDeal";
import { EUGreenDeal2 } from "./Pages/EUGreenDeal2";
import { Inclusion } from "./Pages/Inclusion";
import { Appendix } from "./Pages/Appendix";
import { BackPage } from "./Pages/BackPage";
import { Cover } from "./Pages/Cover";
import BootstrapDropdown from "../../../components/BootstrapDropdown";
import {
  getHighlightList,
  updateHighlightList,
} from "../../../apis/AmbitionList";
import { YearTabContext } from "../../../components/Skeleton";
import { addReportLogo, getReportLogo } from "../../../apis/Report/Report";
import CloudinaryUploadWidget from "../../../components/CloudinaryUploadWidget/CloudinaryUploadWidget";
import { Cloudinary } from "@cloudinary/url-gen";

export const CompanyContext = React.createContext();
export const PRINT_WIDTH = 1197;
export const LogoContext = React.createContext();
const Print = () => {
  const year = React.useContext(YearTabContext);
  const componentRef = React.useRef(null);
  const [companyName, setCompanyName] = useState();
  const [address, setAddress] = useState("");
  const cloudName = "azilisdjo";
  const uploadPreset = "upload";
  const folder = "reportlogo";
  const cld = new Cloudinary({
    cloud: {
      cloudName,
    },
  });

  const [uwConfig] = useState({
    cloudName,
    uploadPreset,
    // cropping: true, //add a cropping step
    // showAdvancedOptions: true,  //add advanced options (public_id and tag)
    // sources: [ "local", "url"], // restrict the upload sources to URL and local files
    multiple: false, //restrict upload to a single file
    folder: folder,
    // tags: ["users", "profile"], //add the given tags to the uploaded files
    // context: {alt: "user_uploaded"}, //add the given context data to the uploaded files
    // clientAllowedFormats: ["images"], //restrict uploading to image files only
    // maxImageFileSize: 2000000,  //restrict file size to less than 2MB
    // maxImageWidth: 2000, //Scales the image down to a width of 2000 pixels before uploading
    // theme: "purple", //change to a purple theme
  });

  const componentsToPrint = [
    <Cover />,
    <CompanyReportInformation />,
    <TableContents />,
    <AmbitionAndStatus />,
    <BrandWay />,
    <OurGoals />,

    <EnvironmentAndOurWorld />,
    <OurEnvironmentalAim keyHighlight={"yourenvironmentalaim"} />,
    <Scope1 img={scope1} keyHighlight={"scope1"} />,
    <Scope2 img={scope2} keyHighlight={"scope2"} />,
    <Scope3 img={scope3} keyHighlight={"scope3"} />,
    <EnergyAndWater />,
    <ActiveParticipation />,
    <Social />,
    <OurEnvironmentalAim
      keyHighlight={"yoursocialaim"}
      title={"Our Social Aim"}
    />,
    <OurWorkplace />,
    <OurHealth />,
    <OurDiversityAndInclusion />,
    <SocialActiveParticipation />,
    <Governance />,
    <OurEnvironmentalAim
      keyHighlight={"yourgovernanceaim"}
      title={"Our Governance Aim"}
      img={governance2}
    />,
    <OurDiversityAndEquality />,
    <OurStakeholderInclusion />,
    <OurRiskAndOpportunitites />,
    <OurCompanyStructure />,
    <OurStateThisYear />,
    <OurTransparency />,
    <OurEnvironmentalAim
      keyHighlight={"governanceactiveparticipation"}
      title={"Active participation"}
      img={governance2}
    />,
    <EUGreenDeal />,
    <EUGreenDeal2 />,
    <Inclusion />,
    <Appendix />,
    <BackPage />,
  ];

  const onBeforeGetContentResolve = React.useRef(null);

  const [loading, setLoading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const [page, setPage] = React.useState(0);
  const [reportOptions, setReportOptions] = React.useState("INTERNAL");
  const [logo, setLogo] = useState(logo_default);
  const [thumbnail, setThumbnail] = useState("DISABLED");
  const [publicId, setPublicId] = useState();

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called"); // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called"); // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
    setLoading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "AwesomeFileName",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    // fonts:[{ family:"SpockPro"}],
    removeAfterPrint: true,
  });

  React.useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  const handleSave = () => {
    addReportLogo({ logo: logo, publicId: publicId });
  };

  const handleNext = () => {
    // console.log(Array.from(componentRef.current.childNodes))
    const children = Array.from(componentRef.current.childNodes).filter(
      (child, i) => {
        // if (i == 0)
        //   return true
        // else
        console.log(window.pageYOffset, child.offsetTop);
        return window.pageYOffset + 10 >= child.offsetTop;
      }
    );
    if (children[children.length - 1]) {
      componentRef.current.childNodes[children.length].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      componentRef.current.childNodes[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handlePrev = () => {
    // console.log(Array.from(componentRef.current.childNodes))
    const children = Array.from(componentRef.current.childNodes).filter(
      (child, i) => {
        // if (i == 0)
        //   return true
        // else
        return window.pageYOffset - 10 >= child.offsetTop;
      }
    );
    if (children[children.length - 1]) {
      componentRef.current.childNodes[children.length - 1].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      componentRef.current.childNodes[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handlePrev2 = () => {
    setPage(Math.max(page - 1, 0));
  };
  const handleNext2 = () => {
    setPage(Math.min(page + 1, componentsToPrint.length - 1));
  };
  useEffect(() => {
    getFirstBusiness({
      setCompanyname: setCompanyName,
      setAddress: setAddress,
    });
  }, []);

  const [grid, setGrid] = useState(0);
  const [customPages, setCustomPages] = useState([]);
  const handleGetCustomPages = () => {
    getHighlightList({
      key: "custom_page",
      setValue: setCustomPages,
    });
  };
  const handleUpdateCustomPages = () => {
    updateHighlightList({
      key: "custom_page",
      value: customPages,
    });
  };

  useEffect(() => {
    handleGetCustomPages();
  }, []);

  useEffect(() => {
    getReportLogo({ setLogo: setLogo });
  }, [year]);

  useEffect(() => {
    console.log(reportOptions);
  }, [reportOptions]);

  // useEffect(() => {
  //     if (customPages.length > 0)
  //       handleUpdateCustomPages()
  // },[customPages])
  return (
    <LogoContext.Provider value={logo}>
      <CompanyContext.Provider value={{ companyName, address }}>
        <div className="output__container__container d-flex mt-3">
          <div>
            <h4 className="report__box p-2" style={{ width: "fit-content" }}>
              UPLOAD YOUR LOGO
            </h4>
            <CloudinaryUploadWidget
              uwConfig={uwConfig}
              setPublicId={setPublicId}
              setLogo={setLogo}
            />
            <div
              className="report__box d-flex align-items-center my-2"
              style={{ width: "fit-content", cursor: "pointer" }}
            >
              <div
                className="w-100 py-2 px-3 h-100"
                style={grid === 0 ? { backgroundColor: "#0000005E" } : {}}
                onClick={() => setGrid(0)}
              >
                <img src={grid3} alt="" />
              </div>
              <div
                className="w-100 py-2 px-3 h-100"
                style={grid === 1 ? { backgroundColor: "#0000005E" } : {}}
                onClick={() => setGrid(1)}
              >
                <img src={grid2} alt="" />
              </div>
            </div>
            <div
              className="d-flex report__box"
              style={{ width: "fit-content" }}
            >
              <div
                className="d-flex report__box p-2"
                style={{ cursor: "pointer" }}
                onClick={handlePrint}
              >
                <h4 className="ms-3 me-2">PRINT</h4>
                {loading ? (
                  <div
                    className={"companydetail__delete " + "delete__style" + 3}
                  >
                    <ClipLoader color="#F2F8F0" size={20} />
                  </div>
                ) : (
                  <PrintIcon className="me-3" />
                )}
              </div>
            </div>
            <div
              className="d-flex report__box align-items-center"
              style={{ width: "fit-content" }}
            >
              <h4 className="mx-3" style={{ width: "fit-content" }}>
                Options:
              </h4>
              <BootstrapDropdown
                goals={[
                  { name: "INTERNAL" },
                  { name: "PUBLIC" },
                  { name: "CUSTOM" },
                ]}
                setImportantVar={setReportOptions}
                importantVar={"name"}
                classStyle={"report__box p-2"}
              />
              {/* <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>INTERNAL</h4>
            <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>PUBLIC</h4>
            <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>CUSTOM</h4> */}
            </div>
            <div
              className="d-flex report__box align-items-center"
              style={{ width: "fit-content" }}
            >
              <h4 className="mx-3" style={{ width: "fit-content" }}>
                Thumbnail:
              </h4>
              <BootstrapDropdown
                goals={[{ name: "DISABLED" }, { name: "ENABLED" }]}
                setImportantVar={setThumbnail}
                importantVar={"name"}
                classStyle={"report__box p-2"}
              />
              {/* <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>INTERNAL</h4>
            <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>PUBLIC</h4>
            <h4 className="report__box p-2 me-2" style={{width:"fit-content"}}>CUSTOM</h4> */}
            </div>
            <div
              className="d-flex report__box"
              style={{ width: "fit-content" }}
            >
              <div
                className="d-flex report__box p-2"
                style={{ cursor: "pointer" }}
                onClick={handleSave}
              >
                <h4 className="ms-3 me-2">SAVE</h4>
                {loading && (
                  <div
                    className={"companydetail__delete " + "delete__style" + 3}
                  >
                    <ClipLoader color="#F2F8F0" size={20} />
                  </div>
                )}
              </div>
            </div>

            {thumbnail === "ENABLED" ? (
              <div className="d-flex thumbnail__box">
                {componentsToPrint.map((thumbnail, index) => {
                  return (
                    <div
                      className="thumbnail__item"
                      onClick={() => {
                        setPage(index);
                      }}
                    >
                      {thumbnail}
                      <div className="thumbnail__page">{index + 1}</div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
          {/* <div className="button__print"> */}
          {/* {
          loading ?
          <div className={"companydetail__delete " + "delete__style"+3} >
            <ClipLoader color="#F2F8F0" size={20} />
          </div>
          :<PrintsIcon style={3} click={handlePrint}/>
        } */}
          {/* <img className="output__navigation" src={prevpage} alt="" onClick={handlePrev2}/>
        <img className="output__navigation" src={nextpage} alt="" onClick={handleNext2}/> */}

          {/* </div> */}
          {/* <button onClick={handlePrint} className="button__print">
          Print
        </button> */}

          <div className="d-flex flex-column w-60">
            {grid === 0 ? (
              <div className="output__top">
                <img
                  className="output__navigation"
                  src={prevpage}
                  alt=""
                  onClick={handlePrev2}
                />
                <h6>Page: </h6>
                <h6 style={{ marginLeft: "10px" }}>
                  {page + 1}/{componentsToPrint.length}
                </h6>
                <img
                  className="output__navigation"
                  src={nextpage}
                  alt=""
                  onClick={handleNext2}
                />
              </div>
            ) : null}
            <div
              className="d-flex"
              style={{
                overflowY: "scroll",
                overflowX: "hidden",
                height: grid === 1 ? "2000px" : "",
              }}
            >
              <div className="output__container">
                <div
                  className="output__wrapper__display"
                  style={{ position: "relative" }}
                >
                  {componentsToPrint.map((comp, i) => {
                    if (i === page || grid === 1)
                      return (
                        <>
                          {reportOptions === "CUSTOM" ? (
                            <div
                              style={{
                                backgroundColor: "#0000005E",
                                position: "absolute",
                                top: "0%",
                                width: "30%",
                                padding: "10px",
                                color: "white",
                                display: "flex",
                              }}
                            >
                              <h5>Print ?</h5>
                              <input
                                className="ms-2"
                                onChange={(e) => {
                                  setCustomPages((prev) => {
                                    if (!e.target.checked) {
                                      updateHighlightList({
                                        key: "custom_page",
                                        value: [...prev, i],
                                      });
                                      return [...prev, i];
                                    } else {
                                      updateHighlightList({
                                        key: "custom_page",
                                        value: prev.filter((p) => p !== i),
                                      });
                                      return prev.filter((p) => p !== i);
                                    }
                                  });
                                }}
                                type="checkbox"
                                id="vehicle1"
                                name="vehicle1"
                                value="Bike"
                                checked={!customPages.includes(i)}
                              />
                            </div>
                          ) : null}
                          {comp}
                        </>
                      );
                  })}
                </div>
              </div>
            </div>
            {grid === 0 ? (
              <div className="output__top">
                <img
                  className="output__navigation"
                  src={prevpage}
                  alt=""
                  onClick={handlePrev2}
                />
                <h6>Page: </h6>
                <h6 style={{ marginLeft: "10px" }}>
                  {page + 1}/{componentsToPrint.length}
                </h6>
                <img
                  className="output__navigation"
                  src={nextpage}
                  alt=""
                  onClick={handleNext2}
                />
              </div>
            ) : null}
          </div>
          <div style={{ display: "none" }}>
            <Output1
              ref={componentRef}
              componentsToPrint={componentsToPrint}
              customPages={customPages}
              reportOptions={reportOptions}
            />
          </div>
        </div>
      </CompanyContext.Provider>
    </LogoContext.Provider>
  );
};

const Output1 = React.forwardRef((props, ref) => {
  return (
    <div className="output__container">
      <div className="output__wrapper" ref={ref}>
        {props.componentsToPrint &&
          props.componentsToPrint.map((comp, i) => {
            console.log(props.reportOptions === "CUSTOM");
            if (props.reportOptions === "CUSTOM") {
              if (!props.customPages.includes(i)) return comp;
            } else if (props.reportOptions !== "CUSTOM") {
              return comp;
            }
          })}
      </div>
    </div>
  );
});

const Output = () => {
  return <Print />;
};

export default Output;
